// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lGJG","questions":"styles_questions__1cN5F","footer":"styles_footer__31LQZ"};